var LocationSearchQueryService = (function () {
    function LocationSearchQueryService($location, searchConfiguration, queryBuilder) {
        this.$location = $location;
        this.searchConfiguration = searchConfiguration;
        this.queryBuilder = queryBuilder;
    }
    LocationSearchQueryService.prototype.build = function () {
        var _this = this;
        return this.searchConfiguration.get().then(function (searchConfiguration) {
            var search = _this.$location.search();
            var filters = (search.filters || '').split(';');
            var query = _this.queryBuilder.build(searchConfiguration.filterGroups, filters);
            var availableState = _this.queryBuilder.getIncludeDiscontinuedType(filters);
            var orderBy = (search.orderBy || '')
                .split(',')
                .filter(function (x) { return x !== ''; })
                .map(function (x) { return x.trim(); });
            return { orderBy: orderBy, query: query, availableState: availableState };
        });
    };
    LocationSearchQueryService.$inject = ['$location', 'searchConfiguration', 'queryBuilder'];
    return LocationSearchQueryService;
}());
export { LocationSearchQueryService };
